import React, { useEffect, useState } from 'react';

import local from "../../assets/icons/icon-location.svg";
import iconSucess from "../../assets/icons/totvs/icon-sucess.svg"
import iconAgronomo from "../../assets/icons/icon-user-com-chapeu.svg";

import iconAgronomoWhite from "../../assets/icons/totvs/icon-farmer-white.png";
import iconLocationWhite from "../../assets/icons/totvs/icon-location-white.png";

import iconWarningOrange from "../../assets/icons/icon-warning-orange.png";
import iconNotAllowedGray from "../../assets/icons/icon-not-allowed-gray.svg";

import * as S from './styles';
import { theme } from '../../styles/theme';
import { TaglinePSpan } from '../../styles/stylesTypography';

const VARIANT_ICON = {
  accepted: iconSucess,
  warning: iconWarningOrange,
  disabled: iconNotAllowedGray,
};

const VARIANT_BACKGROUND = {
  accepted: theme.colors.green.Fundo,
  warning: theme.colors.orange.fundo,
  disabled: "transparent",
};

const VARIANT_COLOR = {
  accepted: theme.colors.green.Verde_AgroReceita,
  warning: theme.colors.orange.Laranja_Sudeste,
  disabled: theme.colors.gray.Cinza_7,
};

const TextOrStatus = ({
  type,
  status,
  textDefault,
  textSuccess,
  textError,
  textWaiting,
  textSolicitacaoCancelada,
  imageSrcType,
  disabled,
  align,
  color,
  maxWidth,
  minWidth,
  backgroundColor,
  noEllipsis,
  variant,
  text,
}) => {
  // type - text ou status

  //Default - Fundo cinza
  //Success - Fundo verde
  //Error - Fundo vermelho - Aparece se não for default ou success

  //textDefault - Texto pro status cinza
  //textSuccess - Texto pro status verde
  //textError - Texto pro status vermelho - Aparece se não for default ou success

  // variant - "accepted" | "warning" | "disabled" - pill genérica com ícone próprio,
  // usada fora do domínio de situação de receita (status numérico 1-5)

  const identificaStatus = (status) => {
    //1 - Em aberto
    //2 - Receita Gerada
    //3 - Receita cancelada
    //4 - Solicitação cancelada
    //5 - Aguardando liberação

    switch (status) {
      case 1:
        return 'default';
      case 2:
        return 'success';
      case 3:
        return 'error';
      case 4:
        return 'error';
      case 5:
        return 'waiting';
      default:
        return 'default';
    }
  };

  const [statusState, setStatusState] = useState(status);

  useEffect(() => {
    setStatusState(identificaStatus(status));
  }, [status]);

  if (variant) {
    return (
      <S.Container
        backgroundColor={VARIANT_BACKGROUND[variant]}
        maxWidth="none"
        noEllipsis
        hasImage
      >
        <img src={VARIANT_ICON[variant]} alt="" width={16} height={16} />

        <TaglinePSpan title={text} color={VARIANT_COLOR[variant]}>
          {text}
        </TaglinePSpan>
      </S.Container>
    );
  }

  const displayText =
    status === 4 ? (textSolicitacaoCancelada || textError) : (
      statusState === 'default' ? textDefault :
      statusState === 'success' ? textSuccess :
      statusState === 'error' ? textError :
      textWaiting
    );

  return (
    <S.Container 
      status={statusState} 
      disabled={disabled} 
      align={align} 
      maxWidth={maxWidth} 
      minWidth={minWidth} 
      backgroundColor={backgroundColor} 
      noEllipsis={noEllipsis}
      hasImage={imageSrcType || (statusState !== 'default' && statusState !== 'success')}
    >
      {type === 'status' && (
        <>
          {statusState !== 'success' && (
            <S.StatusCircle status={statusState} />
          )}

          {statusState === 'success' && (
            <img src={iconSucess} alt="Sucesso" width={12} height={12} />
          )}
        </>
      )}

      {type === 'text' && imageSrcType && (
        imageSrcType === 'local' ? (
          disabled ? (
            <img src={iconLocationWhite} alt="Localização" width={16} height={16} />
          ) : (
            <img src={local} alt="Localização" width={16} height={16} />
          )
        ) : imageSrcType === 'agronomo' ? (
          disabled ? (
            <img src={iconAgronomoWhite} alt="Agrônomo" width={16} height={16} />
          ) : (
            <img src={iconAgronomo} alt="Agrônomo" width={16} height={16} />
          )
        ) : null
      )}

      <TaglinePSpan 
        title={displayText} 
        color={disabled ?  theme.colors.white.Branco : color ? color
          : statusState === 'default' ? theme.colors.gray.Cinza_2 
          : statusState === 'success' ? theme.colors.green.Folha : 
          statusState === 'error' ? theme.colors.red.Tostado : 
          theme.colors.yellow.Amarelo}
          >
          {displayText}
      </TaglinePSpan>
    </S.Container>
  );
};

export default TextOrStatus;
